export default "__VITE_ASSET__a1995a94__"